export default "__VITE_ASSET__CcdZ067D__"